import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c42572ac: FaireBrandEntity = {
  token: "b_c42572ac",
  type: "brand",
  name: "Moby",
  avatarUrl:
    "https://cdn.faire.com/fastly/6d2c8b139c443cb274eb494201f1ab1ebd307fbe1fcb489865696ac961c1f1e8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/575b1c2132de1956ec12e294b7976fe14395d5189d198e37328cc15e89fb36e0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6d2c8b139c443cb274eb494201f1ab1ebd307fbe1fcb489865696ac961c1f1e8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/575b1c2132de1956ec12e294b7976fe14395d5189d198e37328cc15e89fb36e0.jpeg",
  location: " Los Angeles, CA, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 21,
  isInsider: true,
  description:
    "An immediate category leader after introducing our classic wrap in 2003, the MOBY name (mother & baby) is synonymous with baby wearings. Globally, we are trusted experts. A brand that knows the importance of keeping babies close, calm and happy. We’re focused on creating products that encourage bonding over special moments, shared discoveries and within the day-to-day of being close enough to kiss™. We innovate to meet the varying needs of today's parent and baby, with designs developed to adapt with baby's comfort, safety, versatility and effortless style.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:27.142Z",
    importedBy: "entity-db-cli",
  },
};
